import StartDateIcon from './component.jsx'
export default StartDateIcon
